import React from "react";
import { AccessTime, CameraOutlined, Dashboard, Folder as FolderIcon, Share, StarBorder } from "@mui/icons-material";

import { SearchScope } from "./useSearchScope";

const iconSx = { fontSize: 16, color: "secondary.main" };

const scopeConfig: Record<SearchScope["type"], { icon: React.ReactElement; label: string }> = {
  workspace: { icon: <Dashboard sx={iconSx} />, label: "Workspace" },
  recent: { icon: <AccessTime sx={iconSx} />, label: "Recent" },
  shared: { icon: <Share sx={iconSx} />, label: "Shared with me" },
  starred: { icon: <StarBorder sx={iconSx} />, label: "Starred" },
  market_lens: { icon: <CameraOutlined sx={iconSx} />, label: "Market Lens" },
  folder: { icon: <FolderIcon sx={iconSx} />, label: "Folder" },
};

export const getScopeIcon = (scope: SearchScope): React.ReactElement => scopeConfig[scope.type].icon;

export const getScopeLabel = (scope: SearchScope): string => scope.folderName ?? scopeConfig[scope.type].label;
